import React, { useState, useEffect } from 'react';
import { stringFormat } from '@ey/utils';
import { labels } from '../../../util/utils';
import styled, { ThemeProvider } from 'styled-components';

function LevelLegends(props) {
	const [legends, setLegends] = useState([0]);

	useEffect(() => {
		if (_.size(props.nodes) > 0) {
			SetLegendLevels(props.nodes);
		}
	}, []);

	useEffect(() => {
		if (_.size(props.nodes) > 0) {
			SetLegendLevels(props.nodes);
		}
	}, [props.nodes]);

	const SetLegendLevels = (nodes) => {

		if (nodes.length > 1) {
			let foundLastNodesElements = nodes.some(function (value) {
				if (value.tags) {
					return value.tags[0] === 'lastNodeElements';
				}
			});

			if (foundLastNodesElements) {
				setLegends([0, 1, 2, 3]);
			}
			else {
				let isLevel3Exist = nodes.some(function (value) {
					if (value.tags) {
						return value.tags[0] === 'middleNodeElements' && value.pid != 1;
					}
				});
				if (isLevel3Exist) {
					setLegends([0, 1, 2]);
				}
				else {
					setLegends([0, 1]);
				}
			}
		}
		else {
			setLegends([0]);
		}

	}

	return (
		<StyledLegendsSection className="legends-wrap" id="legend">
			<section className="legend-content">
				{legends.length > 0 &&
					legends?.map((ele, index) => {
						switch (index) {
							case 0: return (<section key={index} className='level-wrap'><span className='level level1' id="manager"></span>  {stringFormat(labels.level, parseInt(index + 1))}</section>);
							case 1: return (<section key={index} className='level-wrap'><span className='level level2'></span> {stringFormat(labels.level, parseInt(index + 1))}</section>);
							case 2: return (<section key={index} className='level-wrap'><span className='level level3'></span>  {stringFormat(labels.level, parseInt(index + 1))}</section>);
							case 3: return (<section key={index} className='level-wrap'><span className='level level4'></span> {stringFormat(labels.level, parseInt(index + 1))}</section>);
							default:
								console.log('Legend not match')
						}
					})
				}
			</section>
		</StyledLegendsSection>
	);
}
export default LevelLegends;

const StyledLegendsSection = styled.section`
&.legends-wrap {
    position: absolute;
    top: 2rem;
    left: 2rem;
    z-index: 1;
    background-color:${(props) => props.theme.color[`grey100`]};
    padding: 1rem;
    border-radius: 0.4rem;
}

.legend-content{
    font-size: 1rem;
    font-weight: 300;
    .level-wrap{
        display: flex;
    align-items: center;
    }
}

.level{
    width: 1rem;
    height:1rem;
    border-radius: 0.2rem;
    display: inline-block; 
    margin-right: 0.5rem;
}

.level1 {     
    background-color:${(props) => props.theme.color[`green400`]};
}

.level2 {
    background-color:${(props) => props.theme.color[`blue400`]};
}

.level3 {
    background-color:${(props) => props.theme.color[`orange400`]};
}
.level4 {
    background-color:${(props) => props.theme.color[`purple200`]};
}
`;
